'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _semanticUiReact = require('semantic-ui-react');

var _formatting = require('./../../utils/formatting');

var _notAvailableComponent = require('../not-available-component');

var _notAvailableComponent2 = _interopRequireDefault(_notAvailableComponent);

var _privateDataComponent = require('../private-data-component');

var _privateDataComponent2 = _interopRequireDefault(_privateDataComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var METRIC_NAME = 'reach';
var ReachComponent = function ReachComponent(_ref) {
  var post = _ref.post,
      inGIMode = _ref.inGIMode;
  var insights = post.latestStatistic.insights;
  var latestInsights = post.latestInsights,
      estimated = post.estimated;


  var isReel = post.isReel;

  var _post$trackedAsset = post.trackedAsset,
      platform = _post$trackedAsset.platform,
      supportingData = _post$trackedAsset.supportingData;


  if (platform === 'YOUTUBE') {
    return _react2.default.createElement(_notAvailableComponent2.default, { platform: platform, metricName: METRIC_NAME, assetType: 'video' });
  }

  var hasSupportingData = supportingData && supportingData.length;
  var hasInsightsError = insights && insights.error;
  if (platform === 'INSTAGRAM' && hasInsightsError && !hasSupportingData) {
    return _react2.default.createElement(_semanticUiReact.Popup, {
      trigger: _react2.default.createElement(_semanticUiReact.Icon, { color: 'orange', name: 'warning circle' }),
      content: insights.error.error_user_msg
    });
  }

  if ((platform === 'INSTAGRAM' || platform === 'FACEBOOK') && inGIMode && _lodash2.default.has(post, 'finalReach')) {
    return _react2.default.createElement(
      'span',
      null,
      (0, _formatting.sciFormatted)(_lodash2.default.get(post, 'finalReach'))
    );
  }

  // this is where ESTIMATED REELS get rendered
  if (platform === 'INSTAGRAM' && insights && !hasInsightsError) {
    return _react2.default.createElement(
      'span',
      null,
      (0, _formatting.sciFormatted)(post.latestStatistic.insights.reach)
    );
  }

  var latestSupportingData = void 0;

  if (hasSupportingData) {
    var filtered = _lodash2.default.filter(supportingData, 'createdDate'); // remove the GraphQL null at [0]
    var ordered = _lodash2.default.reverse(_lodash2.default.sortBy(filtered, function (o) {
      return o.createdDate;
    }));
    latestSupportingData = ordered[0];
  }

  if (insights && platform === 'FACEBOOK') {
    return _react2.default.createElement(
      'span',
      null,
      (0, _formatting.sciFormatted)(insights.reach || insights.postImpressionsUnique)
    );
  }

  if (latestInsights && platform === 'FACEBOOK') {
    return _react2.default.createElement(
      'span',
      null,
      (0, _formatting.sciFormatted)(latestInsights.reach || latestInsights.totalVideoImpressionsUnique)
    );
  }

  if (latestInsights && platform === 'TWITTER') {
    return _react2.default.createElement(
      'span',
      null,
      (0, _formatting.sciFormatted)(latestInsights.reach)
    );
  }

  if (latestInsights && platform === 'INSTAGRAM') {
    return _react2.default.createElement(
      'span',
      null,
      (0, _formatting.sciFormatted)(latestInsights.reach)
    );
  }

  if (latestSupportingData) {
    return _react2.default.createElement(
      'span',
      null,
      (0, _formatting.sciFormatted)(latestSupportingData.reach)
    );
  }

  if (platform === 'INSTAGRAM' && isReel && !estimated) {
    return _react2.default.createElement(_notAvailableComponent2.default, { platform: platform, metricName: METRIC_NAME, assetType: 'REELS' });
  }

  if (platform === 'INSTAGRAM' && !latestSupportingData) {
    return _react2.default.createElement(_privateDataComponent2.default, { post: post });
  }

  return _react2.default.createElement(_notAvailableComponent2.default, {
    metricName: METRIC_NAME,
    platform: post.trackedAsset.platform,
    assetType: post.trackedAsset.assetType
  });
};

exports.default = ReachComponent;


/*****************
 ** WEBPACK FOOTER
 ** ./~/dyzio-shared-components/lib/reports/reach-component/index.js
 ** module id = 2620
 ** module chunks = 0
 **/